<template>
  <div class="all">
    <!-- 區塊一 -->
    <section id="section1" class="section1">
      <subNav></subNav>
      <div class="custom-container">
        <div class="page-header" data-aos="zoom-in" data-aos-duration="800">
          <h3 class="title">社群行銷</h3>
          <ul class="content">
            <li>策略性創意企劃</li>
            <li>社群媒體整合</li>
            <li>設定目標客群</li>
            <li>精準客群投放廣告</li>
            <li>調整分析廣告內容</li>
            <li>平台數據及成效報表</li>
            <li>研討廣告成效</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 區塊二 -->
    <section class="section2">
      <div class="custom-container">
        <h1 class="header" data-aos="fade-up" data-aos-duration="800">為什麼要做社群</h1>
        <div class="content" data-aos="fade-up" data-aos-duration="800">
          <h3>讓所有人「參與你的行銷」<br>讓你的「社群」成為品牌的主角</h3>
          <p>
            為什麼許多企業的社群行銷做不起來？<br>
            因為市面上充斥著過多粗糙氾濫的業配文，以及沒有行銷策略地的轟炸性銷售文。<br>
            消費者非常聰明，業配文和不適當的廣告已經無法打動他們。
          </p>
          <p>
            要說好一個品牌故事，透過等同於第二官網的社群媒體，<br>
            讓消費者「參與」你的行銷、替你放大聲量提高你的品牌形象。  
          </p>
        </div>
        <div class="social-advantage d-flex">
          <div class="item" data-aos="zoom-in" data-aos-duration="800">
            <img class="social-icon" src="/static/images/service/social/icon_social1.svg" alt="">
            <div class="text">社群平台等同於<br>第二個官網</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="300">
            <img class="social-icon" src="/static/images/service/social/icon_social2.svg" alt="">
            <div class="text">長期的資訊曝光</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="600">
            <img class="social-icon" src="/static/images/service/social/icon_social3.svg" alt="">
            <div class="text">現代人與社群平台<br>黏著度高</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="900">
            <img class="social-icon" src="/static/images/service/social/icon_social4.svg" alt="">
            <div class="text">多種社群平台<br>受眾不同且缺一不可</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 區塊三 -->
    <section class="section3">
      <div class="custom-container">
        <div class="slogan-wrap d-flex align-items-center justify-content-center"  data-aos="fade-up" data-aos-duration="800">
          <div class="braces">{</div>
          <div class="text desktop">
            <h5>社群行銷</h5>
            <h6>你必須身在其中，而不能置身事外</h6>
          </div>
          <div class="braces">}</div>
        </div>
        <div class="social-focus d-flex">
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="100">
            <div class="mobile-num">1</div>
            <img src="/static/images/service/social/icon_focus1.svg" alt="" class="icon">
            <div class="text desktop">1. 全方位策略性規劃‎</div>
            <div class="text mobile">全方位<br>策略性規劃‎</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="200">
            <div class="mobile-num">2</div>
            <img src="/static/images/service/social/icon_focus2.svg" alt="" class="icon">
            <div class="text desktop">2. 針對品牌設計專案</div>
            <div class="text mobile">針對品牌‎<br>設計專案</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="300">
            <div class="mobile-num">3</div>
            <img src="/static/images/service/social/icon_focus3.svg" alt="" class="icon">
            <div class="text desktop">3.設定目標客群</div>
            <div class="text mobile">設定<br>目標客群</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="400">
            <div class="mobile-num">4</div>
            <img src="/static/images/service/social/icon_focus4.svg" alt="" class="icon">
            <div class="text desktop">4.精準客群投放廣告</div>
            <div class="text mobile">精準客群<br>投放廣告‎</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="500">
            <div class="mobile-num">5</div>
            <img src="/static/images/service/social/icon_focus5.svg" alt="" class="icon">
            <div class="text desktop">5. 社群廣告刊登</div>
            <div class="text mobile">社群廣告<br>刊登‎</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="600">
            <div class="mobile-num">6</div>
            <img src="/static/images/service/social/icon_focus6.svg" alt="" class="icon">
            <div class="text desktop">6. 調整分析廣告內容</div>
            <div class="text mobile">調整分析<br>廣告內容‎</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="700">
            <div class="mobile-num">7</div>
            <img src="/static/images/service/social/icon_focus7.svg" alt="" class="icon">
            <div class="text desktop">7. 平台數據及成效報表</div>
            <div class="text mobile">平台數據及<br>成效報表</div>
          </div>
          <div class="item" data-aos="zoom-in" data-aos-duration="800" data-aos-delay="800">
            <div class="mobile-num">8</div>
            <img src="/static/images/service/social/icon_focus8.svg" alt="" class="icon">
            <div class="text desktop">8. 研討廣告成效</div>
            <div class="text mobile">研討廣告<br>成效‎</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import subNav from './subNav.vue';
  export default {
    name: 'Service-social',
    components: {
      subNav
    },
    data() {
      return {

      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/service/social/section1.scss';
  @import 'src/assets/scss/service/social/section2.scss';
  @import 'src/assets/scss/service/social/section3.scss';


</style>



// WEBPACK FOOTER //
// src/components/Social.vue